export default __webpack_public_path__ + "static/media/ac_mode_fan.7422220b.svg";